/** @format */

import React, { useState } from 'react';

import { Input, DatePicker, Button } from 'antd';
import Board from './components/board';
import './index.less';

const testData = new Array(4).fill({
  id: 111,
  status: '1',
  createTime: '2020-01-01',
});

export default () => {
  const [total, setTotal] = useState(108); // 查询结果数
  const [acceptCount, setAcceptCount] = useState(2); // 通过数量

  return (
    <div className='insGroupContainer'>
      <div className='header'>
        <div className='filters'>
          <div className='filterItem'>
            <div className='label'>入库时间：</div>
            <div className='value'>
              <DatePicker showTime />
            </div>
          </div>
          <Button className='searchBtn'>查询</Button>
          <Button className='resetBtn'>重制标签</Button>
        </div>
        <div className='searchResult'>
          <div className='resultItem'>
            <div className='label'>查询结果数：</div>
            <div className='value'>{total}套</div>
          </div>
          <div className='resultItem'>
            <div className='label'>已通过：</div>
            <div className='value'>{acceptCount}套</div>
          </div>
        </div>
      </div>
      <div className='content'>
        {testData.map((item, index) => (
          <Board
            data={item}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};
